export const alaskaCountiesList = [
    'Aleutians East',
    'Aleutians West',
    'Anchorage',
    'Bethel',
    'Bristol Bay',
    'Denali',
    'Dillingham',
    'Fairbanks North Star',
    'Haines',
    'Juneau',
    'Kenai Peninsula',
    'Ketchikan Gateway',
    'Kodiak Island',
    'Lake And Peninsula',
    'Matanuska-Susitna',
    'Nome',
    'North Slope',
    'Northwest Arctic',
    'Prince of Wales-Outer Ketchikan',
    'Sitka',
    'Skagway',
    'Southeast Fairbanks',
    'Valdez-Cordova',
    'Wade Hampton',
    'Wrangell',
    'Yakutat',
    ]